const sectionFieldsetStyles = () => ({
  root: {
    position: 'relative',
    border: '1px solid #B3B0A8',
    borderRadius: 12,
    padding: '24px 18px 24px',
  },
  label: {
    position: 'absolute',
    top: 0,
    left: 14,
    transform: 'translateY(-50%)',
    padding: '0 6px',
    backgroundColor: '#FFFFFF',
    textTransform: 'uppercase',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '.08em',
    color: '#5F5D57',
  },
})

export default sectionFieldsetStyles
